// extracted by mini-css-extract-plugin
export default {"container":"vOBLw6ua24qu2zOQfF1H"};